import { render, staticRenderFns } from "./CmsPageConstructor.vue?vue&type=template&id=5b34457f&scoped=true&"
import script from "./CmsPageConstructor.vue?vue&type=script&lang=js&"
export * from "./CmsPageConstructor.vue?vue&type=script&lang=js&"
import style0 from "./CmsPageConstructor.vue?vue&type=style&index=0&id=5b34457f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b34457f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
